import { Modal } from "react-bootstrap";
import { HeaderText } from "./HeaderText";
import { Button } from "./Button";

interface TermsModalProps {
    terms: string;
    show: boolean;
    setShow: (b: boolean) => void;
}

export function TermsModal({ terms, show, setShow }: TermsModalProps) {
    return (
        <Modal show={show} size="xl" centered>
            <Modal.Header closeButton>
                <HeaderText>Plan Terms</HeaderText>
            </Modal.Header>
            <Modal.Body>
                <div
                    className="scroll-y-auto"
                    style={{
                        maxHeight: "70vh", 
                        overflowY: "auto",
                        paddingRight: "0.5rem",
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: terms }} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    type="button"
                    className="w-100"
                    onClick={() => setShow(false)}
                >
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}